import { NavLink as NL, NavLinkProps } from 'react-router-dom';
import {
  ReactNode,
} from 'react';
import { asMenuItem } from './MenuItem.utils';
import classNames from 'classnames';

type MenuItemProps = NavLinkProps & {
  icon?: ReactNode;
  children: ReactNode;
}

const NavLink = asMenuItem(NL);

export default function MenuItem({ icon, children, ...rest }: MenuItemProps) {
  return (
    <NavLink
      {...rest}
    >
      {icon ? <div className="size-5 flex items-center justify-center shrink-0">{icon}</div> : null}
      <div className="hidden @[100px]:block">{children}</div>
    </NavLink>
  );
}
